import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Expand } from "lucide-react";
import { PHONE } from "@/data/site";

const CtaTile = ({ className }) => (
  <button data-testid="gallery-cta-tile" onClick={() => scrollToId("contact")} className={`group relative flex flex-col justify-between overflow-hidden rounded-2xl bg-[var(--leaf)] p-6 text-left text-white sm:p-8 ${className}`}>
    <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#cfe8c9]">Your yard next</span>
    <span className="flex items-end justify-between gap-4">
      <span>
        <span className="block font-display text-2xl font-black leading-tight sm:text-4xl">Get a free quote</span>
        <span className="mt-1 block text-sm text-white/80">or call {PHONE}</span>
      </span>
      <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-white text-[var(--leaf)] transition-transform duration-300 group-hover:rotate-45"><ArrowUpRight className="h-5 w-5" /></span>
    </span>
  </button>
);
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { GALLERY, scrollToId } from "@/data/site";
import { Eyebrow, Reveal } from "./Reveal";

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="work" data-testid="gallery-section" className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="mb-12 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <Eyebrow>Past projects</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-black leading-[0.95] sm:text-6xl">Real yards. <span className="font-serif-i font-normal text-[var(--leaf)]">Real results.</span></h2>
          </div>
          <button data-testid="gallery-schedule-btn" onClick={() => scrollToId("contact")} className="self-start rounded-full border border-[var(--leaf)] px-6 py-3 font-bold text-[var(--leaf)] transition-colors hover:bg-[var(--leaf)] hover:text-white sm:self-auto">
            Schedule yours
          </button>
        </Reveal>
        <div className="grid grid-flow-row-dense auto-rows-[150px] grid-cols-2 gap-3 sm:auto-rows-[200px] sm:gap-4 lg:auto-rows-[230px] lg:grid-cols-4">
          {GALLERY.map((g, i) => g.cta ? <CtaTile key="cta" className={g.cls} /> : (
            <motion.button
              key={g.src}
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(g.src)}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.1 }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.07, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-2xl bg-[var(--mist)] ${g.cls}`}
            >
              <img src={g.src} alt={`HF Landscape Solutions project ${i + 1}`} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.07]" />
              <span className="absolute inset-0 bg-gradient-to-t from-[var(--leaf-ink)]/50 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              <span className="absolute bottom-3 right-3 grid h-10 w-10 translate-y-2 place-items-center rounded-full bg-white text-[var(--leaf)] opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                <Expand className="h-4 w-4" />
              </span>
            </motion.button>
          ))}
        </div>
      </div>
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-4xl border-0 bg-transparent p-0 shadow-none" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">Project photo</DialogTitle>
          {active && <img src={active} alt="Project enlarged" className="max-h-[85vh] w-full rounded-2xl object-contain" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};
